<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-content-center align-items-center">

      <!-- Por enviar -->
      <div style="display: flex">
        <router-link to="/shipping-instructions/shipping-instructions-por-enviar" style="border-radius: 60px" >
          <button id="button02" class="button-custom-yellow">
            <i class="fa fa-clock" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-yellow">{{ totalCountSteps.shippingInstructionsPorEnviar }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea01" style="width: 70px"></div>

      <!-- Enviadas  -->
      <div style="display: flex">
        <router-link
          to="/shipping-instructions/shipping-instructions-enviados" style="border-radius: 60px">
          <button id="button03" class="button-custom-green">
            <i class="fa fa-check" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-green">{{ totalCountSteps.shippingInstructionsEnviadas }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea02" style="width: 70px"></div>

      <!-- Por aprobar  -->
      <div style="display: flex">
        <router-link to="/shipping-instructions/shipping-instructions-por-aprobar" style="border-radius: 60px">
          <button id="button03" class="button-custom-blue">
            <i class="fas fa-clipboard-check" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px;margin-left: 50px;display: flex;z-index: 0; position: absolute;">
          <div class="number-circle-blue">{{ totalCountSteps.shippingInstructionsPorAprobar }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea03" style="width: 70px"></div>

      <!-- Por revisar -->
      <div style="display: flex">
        <router-link to="/shipping-instructions/shipping-instructions-por-realizar" style="border-radius: 60px">
          <button id="button03" class="button-custom-dark-green">
            <i class="fas fa-file-signature" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-dark-green">{{ totalCountSteps.shippingInstructionsPorRealizar }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea04" style="width: 70px"></div>

      <!-- Shipping's confirmadas-->
      <div style="display: flex">
        <router-link to="/shipping-instructions/shipping-instructions-confirmados" style="border-radius: 60px">
          <button id="button04" class="button-custom-light-green">
            <i class="fas fa-check-double" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-light-green">{{ totalCountSteps.shippingInstructionsConfirmados }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea05" style="width: 70px"></div>

      <!-- Shipping's rechazadas -->
      <div style="display: flex">
        <router-link
          to="/shipping-instructions/shipping-instructions-rechazados"
          style="border-radius: 60px">
          <button id="button05" class="button-custom-red">
            <i class="fa fa-times" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-red">{{ totalCountSteps.shippingInstructionsRechazados }}</div>
        </div>
      </div>

      <!--Linea separadora -->
      <div class="linea06" style="width: 70px"></div>

      <!-- Templates -->
      <div style="display: flex">
        <router-link to="/shipping-instructions/shipping-instructions-templates" style="border-radius: 60px">
          <button id="button06" class="button-custom-grey">
            <i class="fa fa-file" style="padding-bottom: 20px"></i>
          </button>
        </router-link>
        <div style="width: 30px; margin-left: 50px; display: flex; z-index: 0; position: absolute;">
          <div class="number-circle-grey">{{ totalCountSteps.shippingInstructionsTemplates }}</div>
        </div>
      </div>

    </div>

    <!-- Contenedor de titulos -->
    <div class="d-flex flex-row flex-wrap justify-content-center align-items-center" style="margin-top: -5px">

      <div class="texto-desc mt-2">
        <small><strong>Por enviar</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Enviados</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Por aprobar</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Por realizar</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Confirmados</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Rechazados</strong></small>
      </div>

      <div class="texto-desc mt-2">
        <small><strong>Templates</strong></small>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getTotalCountSteps } from "../../constants/shippinginstructions";

export default {
  methods:{
    ...mapActions("shippinginstructions",[
      "actionSetTotalCountSteps"
    ]),
    async init(){
      const { data } = await getTotalCountSteps() ;
      this.actionSetTotalCountSteps( data ) ;
    }
  },
  computed: {
    ...mapState( "shippinginstructions", ["totalCountSteps"]),
  },

  created(){
    this.init() ;
  }
}

</script>

<style>

.button-custom-yellow {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid  #FFC107;
  background-color: white;
  text-align: center;
  color:  #FFC107;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-yellow:hover {
  border: 3px solid   #FFC107 !important;
  color:   #FFC107 !important;
  background: #e9eff2;
}

.number-circle-yellow {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid #FFC107;
  background-color:  #FFC107;
  color: black;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-yellow {
  border: 3px solid   #FFC107 !important;
  color:  #FFC107 !important;
  background: #fff7cd;
}

.linea01 {
  height: 2.5pt;
  background: linear-gradient(90deg, #FFC107,  #4CAF50);
}

.button-custom-green {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid #4CAF50;
  background-color: white;
  text-align: center;
  color: #4CAF50;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-green:hover {
  border: 3px solid #4CAF50 !important;
  color:#43A047 !important;
  background: #e9eff2;
}

.number-circle-green {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid #4CAF50;
  background-color:#4CAF50;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-green {
  border: 3px solid #4CAF50 !important;
  color:#4CAF50 !important;
  background: #d7ffd7;
}

.linea02 {
  height: 2.5pt;
  background: linear-gradient(90deg, #4CAF50,  #2196F3);
}

.button-custom-blue {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid   #2196F3;
  background-color: white;
  text-align: center;
  color:  #2196F3;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-blue:hover {
  border: 3px solid  #2196F3 !important;
  color:  #2196F3 !important;
  background: #e9eff2;
}

.number-circle-blue {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid  #2196F3;
  background-color: #2196F3;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-blue {
  border: 3px solid  #2196F3 !important;
  color:  #2196F3 !important;
  background: #d6ebff;
}

.linea03 {
  height: 2.5pt;
  background: linear-gradient(90deg, #2196F3, #43A047);
}

.button-custom-dark-green {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid #43A047;
  background-color: white;
  text-align: center;
  color:#43A047;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-dark-green:hover {
  border: 3px solid#43A047 !important;
  color:#43A047 !important;
  background: #e9eff2;
}

.number-circle-dark-green {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid#43A047;
  background-color:#43A047;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-dark-green {
  border: 3px solid#43A047 !important;
  color:#43A047 !important;
  background: #b8f6b3;
}

.linea04 {
  height: 2.5pt;
  background: linear-gradient(90deg, #43A047, #7CB342);
}

.button-custom-light-green {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid #7CB342;
  background-color: white;
  text-align: center;
  color:#7CB342;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-light-green:hover {
  border: 3px solid#7CB342 !important;
  color:#7CB342 !important;
  background: #e9eff2;
}

.number-circle-light-green {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid#7CB342;
  background-color:#7CB342;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-light-green {
  border: 3px solid#7CB342 !important;
  color:#7CB342 !important;
  background: #ecffce;
}

.linea05 {
  height: 2.5pt;
  background: linear-gradient(90deg, #7CB342,#F44336);
}

.button-custom-red {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid #F44336;
  background-color: white;
  text-align: center;
  color: #F44336;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-red:hover {
  border: 3px solid #F44336 !important;
  color: #F44336 !important;
  background: #e9eff2;
}

.number-circle-red {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid #F44336;
  background-color: #F44336;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-red {
  border: 3px solid #F44336 !important;
  color: #F44336 !important;
  background: #fff1f1;
}

.linea06 {
  height: 2.5pt;
  background: linear-gradient(90deg, #F44336, #757575);
}


.button-custom-grey {
  width: 80px;
  height: 80px;
  border-radius: 60px;
  border: 3px solid  #757575;
  background-color: white;
  text-align: center;
  color:  #757575;
  font-size: 30px;
  padding-top: 13px;
}

.button-custom-grey:hover {
  border: 3px solid  #757575 !important;
  color:  #757575 !important;
  background: #e9eff2;
}

.number-circle-grey {
  width: 30px;
  height: 30px;
  border-radius: 60px;
  border: 2px solid  #757575;
  background-color: #757575;
  color: #ffffff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  padding-top: 2pt;
}

.router-link-active .button-custom-grey {
  border: 3px solid  #757575 !important;
  color:  #757575 !important;
  background: #eeeeee;
}

.texto-desc {
  width: 150px;
  height: 20px;
  text-align: center;
  font-size: 14px;
}
</style>
